export interface State {
  isNotice: boolean
  isAlert: boolean
  message: string
}

export interface Context {
  commit: (name: string, payload: object) => void
}

export interface Mutations {
  [key: string]: (state: State, payload?: any) => void
}

export interface Actions {
  [key: string]: (this: any, context: Context, payload?: any) => void
}

export const initialState: State = {
  isNotice: false,
  isAlert: false,
  message: ''
}

export const mutations: Mutations = {
  setMessage(state, payload) {
    state.message = payload.message
    state.isAlert = payload.isAlert
    state.isNotice = true
  },
  clearMessage(state) {
    state.isNotice = false
    state.message = ''
  }
}
export const actions: Actions = {
  async setMessage({ commit }, payload) {
    commit('setMessage', payload)
    await this.$delay(3000)
    commit('clearMessage', {})
  }
}

export default {
  namespaced: true,
  state: () => initialState,
  actions,
  mutations
}
